import { cn } from "@breakout/ui/utils"

export function Skeleton({ className }: { className?: string }) {
	return <div className={cn("rounded bg-bg-secondary motion-safe:animate-pulse", className)} />
}
